import styled from 'styled-components';
import { theme } from '../../../../theme';

export const DivWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DivNumber = styled.div`
  margin-right: 1.154rem;
  width: 3.384rem;
  height: 3.384rem;
  display: flex;
  justify-content: center;
  font-size: 1.231rem;
  font-weight: 600;
  line-height: 3.384rem;
  color: ${theme.colors.textPrimary};
  border-radius: 100%;
  background-color: ${theme.colors.surfaceFront};
  cursor: pointer;
  transition: all 0.3s ease;

  &.active {
    background-color: ${theme.colors.active};
    color: ${theme.colors.white};
  }
`;

export const SpanText = styled.span`
  font-size: 1.078rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};
  cursor: pointer;
  transition: color 0.3s ease;

  &.active {
    color: ${theme.colors.active};
  }
`;
